import React, { useCallback } from 'react';
import { data } from 'hudl-base';
import CreatePasswordPage from './CreatePasswordPage';
import { createPassword } from 'requests/rest/createPassword';

const ConnectedApp = () => {
  const token = data.get('token');
  const email = data.getNullable('email');
  const isValidToken = !!data.getNullable('isValidToken');
  const forward = data.getNullable('forward');

  const onCreatePassword = useCallback(
    (newPassword: string, confirmNewPassword: string) =>
      createPassword(newPassword, confirmNewPassword, token, forward),
    [forward, token],
  );

  return <CreatePasswordPage email={email} isValidToken={isValidToken} onCreatePassword={onCreatePassword} />;
};

export default ConnectedApp;
